<template>
  <div>
    <dashboard-header :text="$t('ui.captionSetting')"/>

    <div class="d-flex align-content-center justify-content-center">
      <v-card elevation="0"
              :loading="loading"
              class="card-border-10 mx-16 w-75">
        <div class="pa-5">

          <data-detail
              header-colon
              :items="items"
              :simple-header="header"
          />
        </div>
        <div class=" m-4">
          <v-btn
              elevation="0"
              class="no-uppercase btn-custom-primary"
              @click="onUpdate"
          >{{ $t('ui.update') }}
          </v-btn>
        </div>
      </v-card>

    </div>
  </div>
</template>

<script>
import {API2} from "../../api";
import i18n from "../../lang/i18n";
import DataDetail from "../base/DataDetail.vue";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      detail: null,
    };
  },
  mounted() {
    this.onTab();
  },
  computed: {
    header() {
      return this.$t("nav.about");
    },
    items() {
      return [
        {
          title: i18n.t("setting.timeRefresh"),
          data: this.detail ? this.detail.timeRefresh : ''
        },
        {
          title: i18n.t("setting.enableSMS"),
          data: this.detail && this.detail.enableSMS === 1
              ? i18n.t("setting.activated")
              : i18n.t("setting.inActivated")
        },
        {
          title: i18n.t("setting.androidTabletVersionCode"),
          data: this.detail ? this.detail.androidTabletVersionCode : ''
        },
        {
          title: i18n.t("setting.androidDoctorVersionCode"),
          data: this.detail ? this.detail.androidDoctorVersionCode : ''
        },
        {
          title: i18n.t("setting.iosDoctorVersionCode"),
          data: this.detail ? this.detail.iosDoctorVersionCode : ''
        },
        {
          title: i18n.t("setting.androidTabletApkUrl"),
          data: this.detail ? this.detail.androidTabletApkUrl : ''
        },
      ]
    }
  },
  methods: {
    onTab() {
      this.getData()
    },
    async getData() {
      let res = await this.get(API2.SETTING)
      if (!res) return
      if (res) {
        this.detail = res;
      }
    },
    onUpdate() {
      this.openTab(1)
    },
  }
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
